/* eslint-disable object-shorthand */
/* eslint-disable no-return-assign */
/* eslint-disable camelcase */
/* eslint-disable no-sequences */
/* eslint-disable no-undef */
/* eslint-disable eqeqeq */
import {
  Box,
  Chip,
  ClickAwayListener,
  Grow,
  IconButton,
  MenuItem,
  MenuList,
  Paper,
  Popper,
  Table,
  TableBody,
  TableContainer,
  TableHead,
  TableRow,
  makeStyles,
} from '@material-ui/core'
import React, { useMemo, useRef, useState } from 'react'
import {
  StyledTableCellBody,
  StyledTableCellHeader,
} from '../../../components/hooks/BaseTableComponents'
import colors from '../../../assets/colors'
import {
  mdiBankOutline,
  mdiCashClock,
  mdiCreditCardOutline,
  mdiDelete,
  mdiDomain,
  mdiDotsVertical,
  mdiNoteEdit,
  mdiTagOutline,
} from '@mdi/js'
import Icon from '@mdi/react'
import { exportFormatedMoney, renderRoute } from '../../../util/utils'
import { usePermissions } from '../../../hooks/usePermission'
import { Link } from 'react-router-dom/cjs/react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { remove } from '../BillingActions'
import {
  useHistory,
  useLocation,
} from 'react-router-dom/cjs/react-router-dom.min'
import BasePopUp from '../../../components/hooks/BasePopUp'
import { TableVirtuoso } from 'react-virtuoso'

// Definido fora do componente para que as referências sejam estáveis entre
// re-renders. Referências instáveis fazem o Virtuoso remontar internamente
// e resetar o scroll a cada mudança de estado.
const VirtuosoTableComponents = {
  Scroller: React.forwardRef((props, ref) => (
    <TableContainer
      {...props}
      style={{
        overflowY: 'auto',
        maxHeight: 'calc(100vh - 280px)',
        ...props.style,
      }}
      ref={ref}
    />
  )),
  Table: props => <Table {...props} stickyHeader />,
  TableHead: React.forwardRef((props, ref) => (
    <TableHead {...props} ref={ref} />
  )),
  TableBody: React.forwardRef((props, ref) => (
    <TableBody {...props} ref={ref} />
  )),
  TableRow,
}

const useStyles = makeStyles({
  // Cada lançamento ocupa duas <tr> (linha principal + linha de detalhes).
  // A borda inferior só aparece na linha de detalhes, para as duas lerem
  // como um bloco só.
  mainCell: {
    borderBottom: 'none',
    paddingTop: '8px',
    paddingBottom: '2px',
  },
  detailCell: {
    paddingTop: '0',
    paddingBottom: '8px',
  },
  indicatorCell: {
    position: 'relative',
  },
  // O indicador é absoluto dentro da célula para acompanhar a altura da
  // linha; as metades de cima e de baixo se encostam formando uma barra só.
  indicator: {
    position: 'absolute',
    left: '50%',
    width: '2px',
    transform: 'translateX(-50%)',
  },
  indicatorTop: {
    top: '8px',
    bottom: 0,
    borderRadius: '5px 5px 0 0',
  },
  indicatorBottom: {
    top: 0,
    bottom: '8px',
    borderRadius: '0 0 5px 5px',
  },
  detailChips: {
    display: 'flex',
    flexWrap: 'wrap',
    gap: '6px',
  },
  chip: {
    height: '20px',
    fontSize: '12px',
    color: colors.textPrimary,
    '& .MuiChip-icon': {
      marginLeft: '6px',
      marginRight: '-2px',
    },
  },
  status: {
    borderRadius: '5px',
    width: '82px',
    height: '19px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: '#FFFF',
    fontSize: '12px',
    textAlign: 'center',
    lineHeight: '12px',
    padding: '4px 0',
  },
  ref: {
    width: '34px',
    height: '34px',
    position: 'absolute',
    backgroundColor: '#FFFF',
    transform: 'rotate(45deg)',
    right: '7px',
    '&:hover': {
      backgroundColor: '#FFFF',
    },
  },
  menuList: {
    padding: '10px',
  },
  menuItem: {
    padding: '0 2px',
    height: 'auto',
    lineHeight: '1',
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
  },
  menuItemLi: {
    width: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-start',
    padding: 0,
    margin: 0,
    borderRadius: 0,
    transition: 'all .4s ease-in-out',
    '&:hover': {
      backgroundColor: 'inherit',
      color: colors.primary,
    },
    fontSize: '14px',
  },
  menuItemLiIcon: {
    marginRight: '12px',
  },
})

const BalanceList = ({ type = 'expenses', data, permissions }) => {
  const classes = useStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const location = useLocation()
  const permissionUser = useSelector(state => state.auth.permissionUser)
  const { hasPermission } = usePermissions()
  const showLaundryColumn = hasPermission('laundry-module', permissionUser)
  // Indicador + contato + valor, vencimento, pagamento, status e ações.
  const columnCount = 7
  const indicatorColor = type == 'expenses' ? colors.error : colors.sucess

  const items = useMemo(
    () =>
      (data || []).flatMap(row => [
        { kind: 'main', row },
        { kind: 'detail', row },
      ]),
    [data]
  )

  const [anchorEl, setAnchorEl] = useState(null)
  const [openRow, setOpenRow] = useState(null)
  // Captura o rect no mousedown, antes do ClickAwayListener (que também usa
  // mousedown no document) poder causar um re-render que invalide o elemento.
  const pendingRectRef = useRef(null)

  const [openDeleteModal, setOpenDeleteModal] = useState(false)
  const [billingToDelete, setBillingToDelete] = useState(null)

  const handleMouseDown = event => {
    pendingRectRef.current = event.currentTarget.getBoundingClientRect()
  }

  const handleToggle = row => {
    if (openRow?.id === row.id) {
      setOpenRow(null)
      setAnchorEl(null)
      return
    }
    const rect = pendingRectRef.current
    setOpenRow(row)
    setAnchorEl({
      getBoundingClientRect: () => rect,
    })
  }

  const handleClose = () => {
    setOpenRow(null)
    setAnchorEl(null)
  }

  const handleListKeyDown = event => {
    if (event.key === 'Tab') {
      event.preventDefault()
      handleClose()
    }
  }

  const handleOpenDeleteModal = (id = null) => {
    if (id) {
      setBillingToDelete(id)
    }
    setOpenDeleteModal(!openDeleteModal)
  }

  const handleConfirmDelete = () => {
    if (billingToDelete) {
      dispatch(remove(billingToDelete))
      history.push(`${location?.pathname}${location.search}`)
      setOpenDeleteModal(false)
      setBillingToDelete(null)
    }
  }

  return (
    <>
      <TableVirtuoso
        style={{ height: 600 }}
        data={items}
        overscan={200}
        initialItemCount={Math.min(60, items.length)}
        computeItemKey={(index, item) =>
          `${item?.row?.id ?? index}-${item?.kind}`
        }
        components={VirtuosoTableComponents}
        fixedHeaderContent={() => (
          <TableRow>
            <StyledTableCellHeader style={{ width: 30 }} />
            <StyledTableCellHeader>Contato Financeiro</StyledTableCellHeader>
            <StyledTableCellHeader style={{ width: 130 }}>
              Valor
            </StyledTableCellHeader>
            <StyledTableCellHeader style={{ width: 100 }}>
              Vencimento
            </StyledTableCellHeader>
            <StyledTableCellHeader style={{ width: 100 }}>
              Pagamento
            </StyledTableCellHeader>
            <StyledTableCellHeader style={{ width: 85 }}>
              Status
            </StyledTableCellHeader>
            <StyledTableCellHeader style={{ width: 75 }}>
              Ações
            </StyledTableCellHeader>
          </TableRow>
        )}
        itemContent={(index, { kind, row } = {}) =>
          kind === 'detail' ? (
            <>
              <StyledTableCellBody
                className={`${classes.detailCell} ${classes.indicatorCell}`}
              >
                <Box
                  className={`${classes.indicator} ${classes.indicatorBottom}`}
                  style={{ backgroundColor: indicatorColor }}
                />
              </StyledTableCellBody>
              <StyledTableCellBody
                className={classes.detailCell}
                colSpan={columnCount - 1}
              >
                <Box className={classes.detailChips}>
                  {[
                    showLaundryColumn && {
                      icon: mdiDomain,
                      label: row?.laundry_name,
                      title: 'Empresa',
                    },
                    {
                      icon: mdiTagOutline,
                      label: row?.cost_center,
                      title: 'Centro de custo',
                    },
                    {
                      icon: mdiCreditCardOutline,
                      label: row?.payment_method,
                      title: 'Forma de pagamento',
                    },
                    {
                      icon: mdiBankOutline,
                      label: row?.bank_name,
                      title: 'Banco',
                    },
                  ]
                    .filter(item => item && item.label)
                    .map(item => (
                      <Chip
                        key={item.title}
                        size="small"
                        variant="outlined"
                        className={classes.chip}
                        icon={<Icon path={item.icon} size={0.55} />}
                        label={item.label}
                        title={item.title}
                      />
                    ))}
                </Box>
              </StyledTableCellBody>
            </>
          ) : (
            <>
              <StyledTableCellBody
                className={`${classes.mainCell} ${classes.indicatorCell}`}
              >
                <Box
                  className={`${classes.indicator} ${classes.indicatorTop}`}
                  style={{ backgroundColor: indicatorColor }}
                />
              </StyledTableCellBody>
              <StyledTableCellBody className={classes.mainCell}>
                {row?.contact}
              </StyledTableCellBody>
              <StyledTableCellBody className={classes.mainCell}>
                {exportFormatedMoney(row?.value)}
              </StyledTableCellBody>
              <StyledTableCellBody className={classes.mainCell}>
                {row?.due_date}
              </StyledTableCellBody>
              <StyledTableCellBody className={classes.mainCell}>
                {row?.payment}
              </StyledTableCellBody>
              <StyledTableCellBody className={classes.mainCell}>
                <Box
                  className={classes.status}
                  style={{
                    backgroundColor: row?.is_paid
                      ? colors.sucess
                      : colors.error,
                  }}
                >
                  {row?.is_paid ? 'Pago' : 'Em aberto'}
                </Box>
              </StyledTableCellBody>
              <StyledTableCellBody className={classes.mainCell}>
                <IconButton
                  size="small"
                  onMouseDown={handleMouseDown}
                  onClick={() => handleToggle(row)}
                >
                  <Icon path={mdiDotsVertical} size={1} />
                </IconButton>
              </StyledTableCellBody>
            </>
          )
        }
      />

      {/* Popper fora do Virtuoso para evitar problemas com reciclagem de DOM */}
      <Popper
        open={Boolean(openRow)}
        anchorEl={anchorEl}
        transition
        placement="bottom-end"
        style={{ zIndex: 99999999 }}
      >
        {({ TransitionProps, placement }) => (
          <Grow
            {...TransitionProps}
            style={{
              transformOrigin: placement === 'bottom' ? 'left-end' : 'top-end',
            }}
          >
            <Paper>
              <ClickAwayListener onClickAway={handleClose}>
                <MenuList
                  autoFocusItem={Boolean(openRow)}
                  onKeyDown={handleListKeyDown}
                  className={classes.menuList}
                >
                  <MenuItem
                    className={classes.ref}
                    style={
                      placement === 'bottom-end'
                        ? { top: '-2px' }
                        : { bottom: '-2px' }
                    }
                  />

                  {renderRoute(['update-billing'], permissions) && (
                    <MenuItem
                      onClick={handleClose}
                      className={classes.menuItem}
                    >
                      <IconButton
                        className={classes.menuItemLi}
                        aria-label="edit"
                        component={Link}
                        to={`/billing/${openRow?.id}/edit${location.search}`}
                      >
                        <Icon
                          path={mdiNoteEdit}
                          size={1}
                          className={classes.menuItemLiIcon}
                        />
                        Editar
                      </IconButton>
                    </MenuItem>
                  )}

                  {![3, 4].includes(openRow?.billing_type?.id) &&
                    renderRoute(['delete-billing'], permissions) && (
                      <MenuItem
                        onClick={handleClose}
                        className={classes.menuItem}
                      >
                        <IconButton
                          className={classes.menuItemLi}
                          onClick={() => handleOpenDeleteModal(openRow?.id)}
                        >
                          <Icon
                            path={mdiDelete}
                            size={1}
                            className={classes.menuItemLiIcon}
                          />
                          Deletar
                        </IconButton>
                      </MenuItem>
                    )}

                  <MenuItem onClick={handleClose} className={classes.menuItem}>
                    <IconButton
                      aria-label="close"
                      component={Link}
                      to={`billing/${openRow?.id}/close${location.search}`}
                      className={classes.menuItemLi}
                    >
                      <Icon
                        path={mdiCashClock}
                        size={1}
                        className={classes.menuItemLiIcon}
                      />
                      Definir pagamento
                    </IconButton>
                  </MenuItem>
                </MenuList>
              </ClickAwayListener>
            </Paper>
          </Grow>
        )}
      </Popper>

      <BasePopUp
        open={openDeleteModal}
        type="error"
        title="Excluir Lançamento"
        message="Deseja realmente excluir este lançamento?"
        handleOpen={handleOpenDeleteModal}
        onConfirm={handleConfirmDelete}
      />
    </>
  )
}

export default BalanceList
